import JobsService from "@/service/JobsService";
import MenuRightSerivce from "@/service/MenuRightService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import SweetAlertService from "@/service/SweetAlertService";
import UserService from "@/service/UserService";
import StoreGetter from "@/constants/StoreGetter";
import { Jobs } from "@/model/Jobs";
import { User } from "@/model/User";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import jobPositionValidationObj from "./S080200-JobPositionValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var jobPositionDataValidationObj = new jobPositionValidationObj();
export default {
  name: "jobPosition",
  mounted() {
    jobPositionDataValidationObj.jobPositionValidation();
    this.assignRights();
    this.getAllStaffGrade();
    this.getAllUsers();
    this.resetJobData();
    this.init();
    this.getAllJobs();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_JobPosition,
    Settings: Settings,
    dictEnum: dictEnum,
    jobs: new Jobs(),
    isEditMode: false,
    jobList: [],
    staffGradeList: [],
    userList: [],
    selectAllJob: false,
    tempJobModel: new Jobs(),
    searchText: "",
    tempUser: new User(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".job-table table thead").height();
      var pagginationHeight = $(".paggination-job").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllUsers() {
      var self = this;
      const obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: false
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        self.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllJobs() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await JobsService.getAllJobsByPagination(obj);
      if (response.data.IsSuccess) {
        self.jobList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllStaffGrade() {
      const obj = {};
      const response = await StaffEmploymentService.getAllStaffgrades(obj);
      if (response.data.IsSuccess) {
        this.staffGradeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getJobDetail() {
      var self = this;
      const obj = {
        jobCode: self.tempJobModel.JobCode,
      };
      const response = await JobsService.getJobDetail(obj);
      if (response.data.IsSuccess) {
        self.jobs = response.data.Data;
        var userDetail = self.userList.find(
          obj => obj.StaffID == self.jobs.FinalApprover
        );
        if (userDetail != null && userDetail != undefined) {
          self.jobs.UserName = self.user.Lang == 'EN' ? userDetail.EngName + ' ' + userDetail.EngLastName : userDetail.ChiLastName + userDetail.ChiName;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllJobRecord: function () {
      var self = this;
      var IsSelected = self.selectAllJob;
      self.jobList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleJobPopup: function () {
      var arrayList = [];
      var self = this;
      self.jobList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteJobModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleJob() {
      var arrayList = [];
      var self = this;
      $('#deleteJobModel').modal('hide');
      self.jobList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        jobList: arrayList,
      };
      const response = await JobsService.deleteJob(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetJobData();
        self.init();
        await self.getAllJobs();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnJobSelect: function (model) {
      this.tempJobModel = model;
    },
    addJob: function () {
      var self = this;
      $('#jobModel').modal('show');
      self.isEditMode = false;
      self.jobs = new Jobs();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveJobData(obj) {
      var self = this;
      const response = await JobsService.addJob(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetJobData();
        self.init();
        await self.getAllJobs();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditJobData(obj) {
      var self = this;
      const response = await JobsService.updateJob(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetJobData();
        self.init();
        await self.getAllJobs();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveJob() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#jobModel').modal('hide');
          const obj = {
            model: {
              JobCode: self.jobs.JobCode,
              CDesc: self.jobs.CDesc,
              EDesc: self.jobs.EDesc,
              StaffGrade: self.jobs.StaffGrade,
              FinalApprover: self.jobs.FinalApprover
            }
          };
          if (self.isEditMode) {
            self.EditJobData(obj);
          }
          else {
            self.saveJobData(obj);
          }
        }
      });
    },
    async editJob() {
      var self = this;
      self.isEditMode = true;
      if (self.tempJobModel.JobCode != "") {
        await self.getJobDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#jobModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetJobData: function () {
      var self = this;
      self.selectAllJob = false;
      self.isEditMode = false;
      self.jobs = new Jobs();
      self.tempJobModel = new Jobs();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeJobPopup: function () {
      var self = this;
      self.selectAllJob = false;
      self.isEditMode = false;
      self.jobs = new Jobs();
      self.tempJobModel = new Jobs();
      self.$validator.reset();
      self.vErrors.clear();
      $('#jobModel').modal('hide');
    },
    OnUserBtnClick: function () {
      $("#userModel").modal("show");
    },
    OnUserSelect: function (model) {
      var self = this;
      self.tempUser = model;
    },
    OnUserModalSelectBtnClick: function () {
      var self = this;
      if (self.tempUser.StaffID != "" && self.tempUser.StaffID != undefined) {
        self.jobs.UserName = self.user.Lang == 'EN' ? self.tempUser.EngName + ' ' + self.tempUser.EngLastName : self.tempUser.ChiLastName + self.tempUser.ChiName;
        self.jobs.FinalApprover = self.tempUser.StaffID;
        const field = self.$validator.fields.find("FinalApprover");
        field.reset();
        self.$validator.errors.remove("FinalApprover", field.scope);
        $("#userModel").modal("hide");
        self.tempUser = new User();
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.WARN_SelectUser));
      }
    },

    FinalApproverName(staffID) {
      const find = this.userList.find((x) => x.StaffID == staffID);
      if (find) {
        return this.user.Lang == 'EN' ? find.EngName + ' ' + find.EngLastName : find.ChiLastName + find.ChiName
      }
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllJobs();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080200-JobPosition/S080200-JobPosition.js